import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Animation from '@components/Animation';
import Portal from '@shared/Portal';

export default function Modal({
  closeOnClickOutside,
  children,
  toggle,
  open,
  id,
  maxWidth,
}) {
  return (
    <Portal id={id}>
      <Animation in={open} name='modal'>
        <ModalWrapper>
          <Scrim
            className='scrim'
            onClick={
              closeOnClickOutside
                ? e => {
                    e.stopPropagation();
                    toggle();
                  }
                : undefined
            }
          />
          <ModalCard
            className='modal'
            onClick={e => e.stopPropagation()}
            maxWidth={maxWidth}
          >
            {children}
          </ModalCard>
        </ModalWrapper>
      </Animation>
    </Portal>
  );
}

Modal.propTypes = {
  closeOnClickOutside: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

Modal.defaultProps = {
  closeOnClickOutside: true,
  open: true,
};

const ModalWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  position: fixed;
  z-index: 10;
`;

const ModalCard = styled.div`
  min-width: min(600px, 100%);
  max-width: ${props => props.maxWidth || props.theme.cardMaxWidth}px;
`;

const Scrim = styled.div`
  background: rgba(0, 0, 0, 0.4);
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  position: absolute;
  z-index: -1;
`;
